import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  gridContainer: {
    height: '100%',
    maxWidth: '1080px',
    margin: '0 auto',
    '& .notifications': {
      display: 'flex',
      flexDirection: 'column',
      gap: 20,
      maxWidth: 1080,
      padding: '20px 20px 0px',
      width: '100%',
      '& > :last-child': {
        marginBottom: '20px',
      },
      [Theme.breakpoints.up('sm')]: {
        padding: '30px 30px 0px',
      },
      [Theme.breakpoints.up('md')]: {
        padding: '30px 40px 0px',
      },
      [Theme.breakpoints.up('lg')]: {
        padding: '30px 24px 0px',
      },
      [Theme.breakpoints.up('xl')]: {
        padding: '30px 0px 0px',
      },
    },
  },
  cancelConfirmationContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: '0',
    width: '100%',
    maxWidth: '1080px',
    fontFamily: Theme.typography.base.regular,
    padding: '0px 20px',
    paddingBottom: '40px',
    [Theme.breakpoints.up('sm')]: {
      padding: '0px 30px',
    },
    [Theme.breakpoints.up('md')]: {
      padding: '0px 40px',
    },
    [Theme.breakpoints.up('lg')]: {
      padding: '0px 24px',
    },
    [Theme.breakpoints.up('xl')]: {
      padding: '0px 0px',
    },
  },
  cancelConfirmationHeader: {
    paddingBottom: '40px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    [Theme.breakpoints.up('md')]: {
      fontSize: Theme.typography.size[9],
    },
  },
  confirmationTitle: {
    fontSize: Theme.typography.size[7],
    lineHeight: '40px',
    color: Theme.palette.primary.main,
    fontFamily: Theme.typography.base.semiBold,
    textAlign: 'center',
    [Theme.breakpoints.up('lg')]: {
      fontSize: Theme.typography.size[9],
    },
  },

  checkIcon: {
    height: '45px',
    width: '45px',
    color: Theme.palette.green,
    marginBottom: '12px',
    [Theme.breakpoints.up('sm')]: {
      height: '45px',
      width: '45px',
    },
  },

  CancelConfirmationMessage: {
    padding: 24,
    fontFamily: Theme.typography.base.regular,
    fontSize: Theme.typography.size[2],
    lineHeight: '24px',
    [Theme.breakpoints.up('md')]: {
      fontSize: Theme.typography.size[3],
      lineHeight: '32px',
    },
    '& span': {
      fontFamily: Theme.typography.base.semiBold,
    },
  },

  CancelConfirmationCta: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    background: Theme.palette.gray[100],
    padding: '16px 24px',
    gap: 24,
    [Theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
}));

export default useStyles;
